import type { ReactElement } from 'react'
import type { TFunction } from 'i18next'
import { CaseInfrastructureFilters } from './CaseInfrastructureFilters'
import { CaseInfrastructureTable } from './CaseInfrastructureTable'
import type { CaseInfrastructureTabState } from './use-case-infrastructure-tab'

interface CaseInfrastructureListSectionProps {
  state: CaseInfrastructureTabState
  t: TFunction<'cases'>
}

export function CaseInfrastructureListSection({
  state,
  t,
}: CaseInfrastructureListSectionProps): ReactElement {
  const {
    search,
    columns,
    modals,
    actions,
    sel,
    mapSet,
    collectionSet,
    endpoints,
    getRelationshipCount,
    loading,
    endpointMut,
  } = state
  return (
    <>
      <CaseInfrastructureFilters
        t={t}
        filterDropdownRef={search.filterDropdownRef}
        showFilterDropdown={search.showFilterDropdown}
        setShowFilterDropdown={search.setShowFilterDropdown}
        selectedFilterField={search.selectedFilterField}
        setSelectedFilterField={search.setSelectedFilterField}
        availableFilters={search.availableFilters}
        addFilter={search.addFilter}
        searchInput={search.searchInput}
        setSearchInput={search.setSearchInput}
        handleSearchKeyDown={search.handleSearchKeyDown}
        clearSearch={search.clearSearch}
        executeSearch={search.executeSearch}
        loading={loading}
        activeFilters={search.activeFilters}
        removeFilter={search.removeFilter}
        activeSearch={search.activeSearch}
        clearAllFilters={search.clearAllFilters}
        selectionCount={sel.count}
        clearAll={sel.clearAll}
      />
      <CaseInfrastructureTable
        endpoints={endpoints}
        visibleColumns={columns.visibleColumns}
        isSelected={sel.isSelected}
        isInSet={mapSet.isInSet}
        isInCollectionSet={collectionSet.isInSet}
        allVisibleSelected={actions.allVisibleSelected}
        someVisibleSelected={actions.someVisibleSelected}
        deleting={endpointMut.deleting}
        bulkDeleting={modals.bulkDeleting}
        handleSelectAllVisible={actions.handleSelectAllVisible}
        handleCheckboxClick={actions.handleCheckboxClick}
        handleLinkButtonContextMenu={actions.handleLinkButtonContextMenu}
        handleMapButtonContextMenu={actions.handleMapButtonContextMenu}
        handleCollectionButtonContextMenu={actions.handleCollectionButtonContextMenu}
        handleDeleteContextMenu={actions.handleDeleteContextMenu}
        handleDeleteSingle={actions.handleDeleteSingle}
        toggleMapSet={mapSet.toggle}
        toggleCollectionSet={actions.toggleCollectionSet}
        setLinkingEndpoint={modals.setLinkingEndpoint}
        setEditingEndpoint={modals.setEditingEndpoint}
        setShowCreateModal={modals.setShowCreateModal}
        getRelationshipCount={getRelationshipCount}
      />
    </>
  )
}
